import type { FormInstance } from '@arco-design/web-react/es/Form';

import { ensureImageRegistryOnForm, readFormImageSourceUrl } from '@/delivery-type-plugin/capabilities/image';
import { INFERENCE_SYSTEM_FIELD } from '@/delivery-type-plugin/capabilities/maas-node-groups/nodeFieldNames';
import { shouldValidateSkuModuleOnForm } from '@/delivery-type-plugin/plugins/_shared/common/sku/skuEnabledModules';

/** 应用实例下一步 / 提交：probe 并补全 registry.server；skuResourceModules 显式 false 时跳过 */
export async function confirmApplicationImageOnForm(form: FormInstance, t: (key: string, options?: Record<string, unknown>) => string) {
  if (!shouldValidateSkuModuleOnForm(form, 'appService')) {
    return { ok: true as const };
  }
  const sourceUrl = readFormImageSourceUrl(
    form,
    [`${INFERENCE_SYSTEM_FIELD}.image`, `${INFERENCE_SYSTEM_FIELD}.url`],
    INFERENCE_SYSTEM_FIELD,
  );
  return ensureImageRegistryOnForm(form, {
    sourceUrl,
    sourceUrlField: `${INFERENCE_SYSTEM_FIELD}.image`,
    emptySourceMessage: t('data-center:please.enter.image'),
    t,
  });
}
